// extracted by mini-css-extract-plugin
export default {"btnContainer":"lateralBtn_btnContainer__-KyQp","lastUpdate":"lateralBtn_lastUpdate__Ae-u9"};